<template>
  <vl-calendar
    @input="(date) => emitDate(date)"
    :is-selected="(date) => date === selectedDate"
    :is-disabled="calculateDisabled"
    :custom-classes="customClasses"
    :selected-date="{ start: startDate, end: endDate }"
    :show-weeks-number="showWeeksNumber"
    :default-date="defaultDate"
    :single-month="singleMonth"
    :first-day-of-week="firstDayOfWeek"
    :minDate="minDate"
    :maxDate="maxDate"
    :change-date="changeDate"
    :lang="lang"
    ref="calendar"
  />
</template>

<script>
import { provide, ref, watchEffect } from "vue";
import VlCalendar from "./vl-calendar";
import { DAYS_SHORTCUTS } from "../constants/days";

export default {
  name: "VlDaySelector",
  model: {
    prop: "selectedDate",
  },
  components: {
    VlCalendar,
  },
  setup(props) {
    const selectDate = ref(props.changeDate);
    const disabledWeekdays = ref(props.disabledWeekdays);

    watchEffect(() => {
      selectDate.value = props.changeDate;
      disabledWeekdays.value = props.disabledWeekdays;
    });

    provide("selectDate", selectDate);
    provide("disabledWeekdays", disabledWeekdays);
  },
  props: {
    startDate: String,
    endDate: String,
    selectedDate: String,
    maxDate: String,
    minDate: String,
    isDisabled: Function,
    customClasses: Object,
    showWeeksNumber: Boolean,
    disabledWeekdays: Array,
    disabledDates: [Object, Array],
    defaultDate: String,
    singleMonth: Boolean,
    changeDate: String,
    firstDayOfWeek: {
      type: String,
      validator: (v) => DAYS_SHORTCUTS.includes(v),
      default: "mo",
    },
    lang: { required: false, default: "DE" },
  },

  methods: {
    calculateDisabled(date) {
      if (date <= this.minDate) {
        return date;
      }
      if (Array.isArray(this.disabledDates)) {
        return this.disabledDates.includes(date);
      } else {
        const from = this.disabledDates.from;
        const to = this.disabledDates.to;

        const isAfterFrom = from && from <= date;
        const isBeforeTo = to && date <= to;

        if (from && to) {
          return isAfterFrom && isBeforeTo;
        }

        if (from) {
          return isAfterFrom;
        }

        if (to) {
          return isBeforeTo;
        }
      }
    },
    emitDate(date) {
      // if (
      //   this.blockStartDate ||
      //   (this.startDate && !this.endDate && date >= this.startDate)
      // ) {
      //   this.$emit("update:endDate", date);
      //   this.$emit("update:changeDate", null);
      // } else {
      //   if (this.changeDate == "end") {
      //     if (date < this.startDate) {
      //       this.$emit("update:startDate", date);
      //       this.$emit("update:endDate", null);
      //       this.$emit("update:changeDate", "end");
      //     } else {
      //       this.$emit("update:endDate", date);
      //       this.$emit("update:changeDate", null);
      //     }
      //   } else {
      //     this.$emit("update:startDate", date);
      //     this.$emit("update:changeDate", "end");
      //     let maxDate = 0;

      //     if (parseInt(this.maxDate) > 0) {
      //       maxDate = new Date(date);
      //       maxDate.setDate(maxDate.getDate() + parseInt(this.maxDate));
      //       maxDate = this.formateDate(maxDate);
      //     }
      //     if (this.endDate < date || (this.endDate > maxDate && maxDate != 0)) {
      //       this.$emit("update:endDate", null);
      //     }
      //   }
      // }
      this.$emit("update:startDate", date);
      this.$emit("update:changeDate", null);
      this.$emit("focus");
    },
    calculateDisabled(date) {
      if (date < this.minDate && this.minDate != null) {
        return date;
      }

      if (parseInt(this.maxDate) > 0 && this.changeDate != "start") {
        let maxDate = new Date(this.startDate);
        maxDate.setDate(maxDate.getDate() + parseInt(this.maxDate));

        if (this.formateDate(maxDate) < date) {
          return date;
        }
      }

      if (Array.isArray(this.disabledDates)) {
        if (date <= 6) {
          return this.disabledWeekdays.includes(date);
        } else {
          return this.disabledDates.includes(date);
        }
      } else {
        const from = this.disabledDates.from;
        const to = this.disabledDates.to;

        const isAfterFrom = from && from <= date;
        const isBeforeTo = to && date <= to;

        if (from && to) {
          return isAfterFrom && isBeforeTo;
        }

        if (from) {
          return isAfterFrom;
        }

        if (to) {
          return isBeforeTo;
        }
      }
    },
  },
};
</script>
